export default function LoadMore({ ctx, pkey, label = "Load more" }) {
  const total = ctx?.totals?.[pkey];
  const loaded = ctx?.loaded?.[pkey] ?? 0;
  const more = total != null ? loaded < total : !!ctx?.hasMore?.[pkey];
  if (!more) return null;
  return (
    <div className="pt-4 text-center space-y-2">
      {total != null && (
        <p data-testid={`count-${pkey}`} className="text-xs tracking-[0.15em] uppercase text-stone-400">
          Showing {loaded} of {total}
        </p>
      )}
      <button
        data-testid={`load-more-${pkey}`}
        onClick={() => ctx.loadMore(pkey)}
        className="inline-flex items-center gap-2 px-6 py-2.5 border-2 border-[#121212] text-xs tracking-[0.15em] uppercase font-bold hover:bg-[#121212] hover:text-[#C6FF33] transition-colors rounded-lg"
      >
        {label}
      </button>
    </div>
  );
}
